<template>
    <div @click="toggleSwitch" class="flex items-center justify-start w-11 h-7 rounded-full cursor-pointer" :class="{
        'bg-regal-blue-700 justify-end' : active,
        'bg-gray-500 hover:bg-gray-600' : !active
    }">
        <div class="flex items-center justify-center rounded-full bg-white w-6 h-6 text-regal-blue-700" style="margin: 0.125rem">
            <svg v-if="active" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>
        </div>
    </div>
</template>

<script>
    export default {
        setup(props) {
            const active = props.active ?? ref(false)
            return {active}
        },
        props: [ 'active' ],
        methods: {
            toggleSwitch() {
                this.active = !this.active;
                this.$emit('clicked', this.active);
            }
        }
    }
</script>
